module.exports = __webpack_public_path__ + "img/edit.81d67fa4.svg";